export default {
  init() {
    let $urlVars = this.getUrlVars();

    // CUSTOM CHECKBOX FIELDS CUSTOMISATION FOR WOOCOMMERCE EXTRA OPTIONS PLUGINS
    const $checkboxInputs = $('.extra-options.thwepo_variable .input-checkbox');
    const $toolTips = $('.extra-options.thwepo_variable .thwepo_tooltip');

    // Adding a is-checked class to parent label for styling purposes
    $checkboxInputs.on('change', function() {
      const $el = $(this);
      const $parent = $el.parent().parent('label');
      if($el.prop('checked') == true) {
        $parent.addClass('is-checked');
      } else {
        $parent.removeClass('is-checked');
      }
    });

    $checkboxInputs.each(function() {
      const $checkbox = $(this);
      const $parent = $checkbox.parent();
      const $label = $parent.parent();
      const $tooltip = $parent.find('a');

      // Moving the tooltip anchor from out of the child label.
      if($tooltip.length) {
        $parent.remove($tooltip);
        $tooltip.addClass('tooltip-bubble');
        $tooltip.html('i');
        $parent.parent().append($tooltip);
      }

      // Get values from query string
      if ($urlVars[$checkbox.prop('name')] === '1'){
        $checkbox.prop('checked', true);
      }

      // Adding is-checked class on checkboxes that are checked on page reload.
      if($checkbox.prop('checked')) {
        $label.addClass('is-checked');
      }
    });

    const customRadios = ($el) => {
      // El is the first radio item
      const $noneRadio = $el;
      const $parent = $noneRadio.parent();
      // Hide the none value
      $parent.hide();

      const $radiosWrap = $parent.parent();
      const $radios = $radiosWrap.find('label.radio').not($el);

      $radios.each(function() {
        const $radioEl = $(this);
        const $input = $radioEl.children('input');

        // Get values from query string
        if ($urlVars[$input.prop('name')] === $input.prop('value')){
          $input.prop('checked', true);
          $radioEl.addClass('is-checked');
        }
      });

      // Uncheck the radio on click and check the none input to simulate being able to de-select
      $radios.on('click', function(e) {
        e.preventDefault();
        const $clickedRadioLabel = $(this);
        const $input = $clickedRadioLabel.children('input');
        $radios.removeClass('is-checked');

        // If its already checked then check the none radio - so unchecking the checked one
        if( $input.is(':checked') ) {
          $noneRadio.prop('checked', true).trigger('change');
          $clickedRadioLabel.removeClass('is-checked');
        } else {
          // Not already checked so check it.
          $input.prop('checked', true).trigger('change');
          $clickedRadioLabel.addClass('is-checked');
        }
      });

      // Add custom class to the tooltip to style it.
      // $radiosWrap.parent().css('border', '1px solid red');
      $radiosWrap.parent().find('a.thwepo_tooltip').addClass('tooltip-bubble').html('i');
    }

    customRadios($('#integral_blinds_3p_none'));
    customRadios($('#integral_blinds_4p_none'));
    customRadios($('#integral_blinds_5p_none'));

    $('.next-prod-option-btn').on('click', function() {
      customRadios($('#integral_blinds_3p_none'));
      customRadios($('#integral_blinds_4p_none'));
      customRadios($('#integral_blinds_5p_none'));
    });

    const customRadios2 = ($el) => {
      // El is the first radio item
      const $noneRadio = $el;
      const $parent = $noneRadio.parent();

      const $radiosWrap = $parent.parent();
      const $radios = $radiosWrap.find('label.radio');

      $radios.each(function() {
        const $radioEl = $(this);
        const $input = $radioEl.children('input');

        if($input.is(':checked')) {
          $radioEl.addClass('is-checked');
        }

        // Get values from query string
        if ($urlVars[$input.prop('name')] === $input.prop('value')){
          $input.prop('checked', true);
          $radioEl.addClass('is-checked');
        }
      });

      // Uncheck the radio on click and check the none input to simulate being able to de-select
      $radios.on('click', function() {
        const $clickedRadioLabel = $(this);
        const $input = $clickedRadioLabel.children('input');
        $(this).siblings().removeClass('is-checked');

        // If its already checked then check the none radio - so unchecking the checked one
        if( $input.is(':checked') ) {
          $clickedRadioLabel.addClass('is-checked');
        } else {
          // Not already checked so check it.
          $clickedRadioLabel.removeClass('is-checked');
        }
      });

      $('#pa_size').on('change', function () {
        $radios.each(function() {
          const $radioEl = $(this);
          const $input = $radioEl.children('input');

          if($input.is(':checked')) {
            $radioEl.addClass('is-checked');
          }
        });
      });

      // Add custom class to the tooltip to style it.
      // $radiosWrap.parent().css('border', '1px solid red');
      $radiosWrap.parent().find('a.thwepo_tooltip').addClass('tooltip-bubble').html('i');
    }

    customRadios2($('[id*="glazing"]'));
    customRadios2($('[id*="sidelights"]'));
    customRadios2($('[id*="sidelight"]'));

    $('.next-prod-option-btn').on('click', function() {
      customRadios2($('[id*="glazing"]'));
      customRadios2($('[id*="sidelights"]'));
      customRadios2($('[id*="sidelight"]'));
    });

    const colourMatch = () => {
      if($('body[class*="pre-made"]').length > 0 && $('.exp-colour-checkbox').length > 0 && $('.variation-radios--colour').length > 0) {
        const $frameInputs = $('.exp-colour-checkbox').children('input');

        $frameInputs.on('change', function(){
          var value = $(this).val();
          var handle_value = $(this).val();

          if(value == 'jet-black') {
            handle_value = 'black';
          }

          if(value == 'traffic-white') {
            handle_value = 'white';
          }

          var handles_selector = 'input[value*="'+handle_value+'"]';
          // console.log(handles_selector);

          // $('.exp-colour-checkbox').children('input').not($(this)).prop('checked', false);
          $('.exp-colour-checkbox').children(handles_selector).prop('checked', true);
        })
      }
    }

    colourMatch();

    // const preMadeThreshold = () => {
    //   if($('body[class*="pre-made"]').length > 0 && $('input[value*="rebated"]').length > 0) {
    //     if($('input[value*="rebated"]').parent('.exp-radio-checkbox').siblings('.exp-radio-checkbox').length === 0) {
    //       $('input[value*="rebated"]').closest('.value').prop('style', 'pointer-events: none');
    //     }
    //   }
    // }

    // preMadeThreshold();

    // Custom tooltips for the Extra product options plugin
    $toolTips.on('click', function() {
      const $btn = $(this);
      const title = $btn.attr('title');
      let idFragment = title.toLowerCase();
      idFragment = idFragment.replace(/ /g, '-');
      const modal = $('#modal-pa_' + idFragment);

      $.magnificPopup.open({
        items: {src: modal},
        type: 'inline',
        mainClass: 'mfp-fade',
      }, 0);
    });

    $(document).on('click', '.extra-tooltip', function() {
      const modal = $('#modal-pa_extra-options');
    
      $.magnificPopup.open({
        items: {src: modal},
        type: 'inline',
        mainClass: 'mfp-fade',
      }, 0);
    });

    $('.extra-options.thwepo_variable .sidelight_sizes input').on('change', function() {
      customRadios2($('[id*="sidelight"]'));
    });

    // CUSTOM SELECT FIELDS CUSTOMISATION FOR WOOCOMMERCE EXTRA OPTIONS PLUGINS
    // const $selectInputs = $('.extra-options.thwepo_variable select.thwepo-price-option-field');
  },
  getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
  },
}



// WEBPACK FOOTER //
// ./scripts/components/custom-extra-add-cart-fields.js